import Vue from 'vue'
import Vuex from 'vuex'
// import axios from 'axios'
// import router from '@/router'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    projects: [],
    staff: [],
    features: [],
    journals: []
  },
  getters: {
    projects: state => state.projects,
    staff: state => state.staff,
    features: state => state.features,
    journals: state => state.journals
  },
  mutations: {
    GET_PROJECTS: (state, projects) => {
      state.projects = projects
    },
    GET_STAFF: (state, staff) => {
      state.staff = staff
    },
    GET_FEATURES: (state, features) => {
      state.features = features
    },
    GET_JOURNALS: (state, journals) => {
      state.journals = journals
    }
  },
  actions: {
  },
  modules: {
  }
})
